"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Mon Apr 08 2019
 */

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");

var WindowItemWarningFlag_1 = require("../../window/model/WindowItemWarningFlag");
/**
 * @author Tomáš Leity
 */


var WindowItemTransferValidationDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(WindowItemTransferValidationDTO, _DomainObject_1$Domai);

  /**
   * @param productId
   * @param windowItemId
   * @param flags - validation flags per product id
   */
  function WindowItemTransferValidationDTO(windowItemId, productId, flags) {
    var _this;

    _classCallCheck(this, WindowItemTransferValidationDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(WindowItemTransferValidationDTO).call(this));
    _this.windowItemId = windowItemId;
    _this.productId = productId;
    _this.flags = flags;
    return _this;
  }

  return WindowItemTransferValidationDTO;
}(DomainObject_1.DomainObject);

exports.WindowItemTransferValidationDTO = WindowItemTransferValidationDTO;

WindowItemTransferValidationDTO.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(WindowItemTransferValidationDTO.name);
  return {
    windowItemId: builder.str('windowItemId'),
    productId: builder.str('productId'),
    flags: builder.flags('flags', WindowItemWarningFlag_1.WindowItemWarningFlag)
  };
}();